module.exports = __webpack_public_path__ + "img/album03_01.5721df4c.jpg";